export const isPersonCurrentlyUnassigned = (availabilityDate?: string): boolean => {
    if (!availabilityDate) {
        return false;
    }
    const date = new Date(availabilityDate);
    if (isNaN(date.getTime()) || date.getFullYear() <= 1) {
        return false;
    }
    return date <= new Date();
};
